import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { usePerms } from '../hooks/useAuth';
import HpExportStatus from './HpExportStatus';

export default function HpIntegrationSettings() {
  const { has } = usePerms();
  return <div>
    <Helmet><title>HP-Verbindung und Exportstatus</title></Helmet>
    <h2>Homepage: Verbindung und Exportstatus</h2>
    {has('/itemWebChannelListHP') && <p><Link to="/itemWebChannelListHP">Zur HP-Liste</Link></p>}
    <HpExportStatus connection/>
    <p>„HP-Web-Channel speichern“ erzeugt immer die vollständige JSON-Datei aller freigegebenen, aktiven Maschinen. Änderungen im Artikelstamm werden automatisch übernommen.</p>
    <p>Der Export enthält öffentliche Artikeltexte, Hersteller und Typ, technische Daten, Produktgruppe, Motortyp, Zustand, HP-Preise, Bilder und Dokumentlinks. Interne Notizen, Einkaufspreise und Kundendaten werden nicht exportiert.</p>
  </div>;
}
